import React from 'react';
import Link from 'gatsby-link';
import './_popup.scss';

export default class Accordion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            accepted: false,
        }
    }

    componentDidMount() {

    }

    accept(id) {
        this.setState({
            accepted: true,
        });
    }

    render() {
        return  this.state.accepted ? null : (
            <div id="overlay">
              <div id="popup">
                <h3>Aufgrund der Corona Pandemie sind wir verpflichtet, nur noch akute Untersuchungen durchzuführen.</h3>
                <p>Öffnungszeiten Röntgen:</p>
                <h4>Montag bis Donnerstag<br />
                08:00 Uhr bis 16:00 Uhr<br />
                Freitag<br />
                08:00 Uhr bis 12:00 Uhr</h4>
                <h4>MRT nach Vereinbarung</h4>
                <p class="verstaendnis">Wir bitten um Ihr Verständnis<br />
                Das Team der Radiologie Bregenz</p>
                <button onClick={()=>this.accept()}>Okay</button>
              </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/popup/index.jsx